import { useRef, useEffect } from 'react';
import { useMutation } from 'react-fetching-library';
import { updateDraftDocumentAction } from '../../../services/request';

const useAutoSaveDraft = (order_id, identifier, isSent, delay = 5000) => {
  const { mutate } = useMutation(updateDraftDocumentAction);
  const timeoutIdRef = useRef(null); // Przechowywanie timeoutId

  const handleSave = newData => {
    // Sprawdź, czy formularz został wysłany - jeśli tak, przerwij autosave
    if (isSent) {
      return;
    }
    // Czyścimy poprzednie timeout, jeśli istnieje
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    const updateDraftDocumentMutation = async () => {
      const { error } = await mutate(order_id, identifier, newData); // Przekazywanie newData do mutacji
      if (error) {
        console.log(error);
      }
    };

    // Ustawiamy nowe timeout na określony czas (domyślnie 5 sekund)
    timeoutIdRef.current = setTimeout(() => {
      if (identifier.startsWith('karta_kwalifikacyjna')) {
        console.log('save_qc');
        updateDraftDocumentMutation();
        console.log(newData); // Upewnij się, że wyświetla aktualne dane
      }
    }, delay);
  };

  // Cleanup timeout na odmontowanie komponentu
  useEffect(() => () => clearTimeout(timeoutIdRef.current), []);

  return handleSave; // Zwracamy funkcję, która będzie wywoływana w innym miejscu z newData
};

export default useAutoSaveDraft;
